module.exports = __webpack_public_path__ + "img/texto_blanco.ee82ecdb.webp";